import { render, staticRenderFns } from "./CpFooter.vue?vue&type=template&id=7f134a39&scoped=true&"
import script from "./CpFooter.vue?vue&type=script&lang=js&"
export * from "./CpFooter.vue?vue&type=script&lang=js&"
import style0 from "./CpFooter.vue?vue&type=style&index=0&id=7f134a39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f134a39",
  null
  
)

export default component.exports